import GraphemeSplitter from "grapheme-splitter";

const MAX_CATEGORY_NAME_FIRST_WORD_LENGTH = 18;
const MAX_CATEGORY_NAME_LENGTH = 30;

export const filterLongCategoryName = (name?: string): string | undefined => {
  const firstWord = name?.substring(0, name.indexOf(" "));

  return name !== undefined &&
    firstWord !== undefined &&
    categoryNameLength(firstWord) > MAX_CATEGORY_NAME_FIRST_WORD_LENGTH
    ? firstWord
    : name;
};

export const isLongCategoryName = (name?: string): boolean | undefined => {
  const filteredName = filterLongCategoryName(name);

  return (
    categoryNameLength(filteredName) > MAX_CATEGORY_NAME_LENGTH &&
    filteredName?.includes(" ")
  );
};

const categoryNameLength = (name?: string): number =>
  name ? new GraphemeSplitter().splitGraphemes(name).length : 0;
